export default function headerTemplate () {

	/*
		Clone top level menu link into its dropdown & remove URL from original
		- desktop only
	*/
	const dropdownLinks = document.querySelectorAll('#header-menu-desktop > li.has-children > a');
	if (dropdownLinks) {
		dropdownLinks.forEach((dropdownLink) => {

			// Clone menu link into its dropdown
			const href = dropdownLink.getAttribute('href');
			const html = dropdownLink.innerHTML;

			const clone = document.createElement('li');
			clone.className = 'menu-item main';
			clone.innerHTML = `<a class='nav-link' href='${href}'>${html}</a>`;

			const submenuId = dropdownLink.getAttribute('data-dropdown-toggle');
			const submenu = document.getElementById(submenuId);
			submenu.prepend(clone);


			// Remove URL from original link - opens dropdown only
			dropdownLink.setAttribute('href', '#');

			dropdownLink.addEventListener('click', (e) => {
				e.preventDefault();
			});

		});
	}



	/*
		Toggle search form in menu
		- desktop only
	*/
	const searchForm = document.querySelector('#nav-desktop .search-form');
	if (searchForm) {

		const searchInput = searchForm.querySelector('input');
		const searchButton = searchForm.querySelector('button');

		searchInput.setAttribute('tabindex', '-1');
		searchInput.setAttribute('aria-expanded', 'false');

		let searchFlag = false;

		// Collapse search form when it loses focus, e.g. click outside
		// (neither the input nor button has focus)
		searchForm.addEventListener('focusout', function () {
			setTimeout(() => {
				if (! this.contains(document.activeElement)) {

					// enable interaction only when animation is done
					if (searchFlag) {
						return false;
					} else {
						searchFlag = true;
						setTimeout(() => { searchFlag = false; }, 300);
					}
					
					searchForm.classList.remove('expanded');

					searchInput.setAttribute('tabindex', '-1');
					searchInput.setAttribute('aria-expanded', 'false');

				}
			}, 0);
		});

		// Toogle search expand on button click
		searchButton.addEventListener('click', (e) => {

			e.preventDefault();

			// enable interaction only when animation is done
			if (searchFlag) {
				return false;
			} else {
				searchFlag = true;
				setTimeout(() => { searchFlag = false; }, 300);
			}

			// collapse form or submit if input has value
			if (searchForm.classList.contains('expanded')) {

				if (searchInput.value) {

					searchForm.submit();

				} else {

					searchForm.classList.remove('expanded');

					searchButton.focus();

					searchInput.setAttribute('tabindex', '-1');
					searchInput.setAttribute('aria-expanded', 'false');

				}

			}
			// expand form
			else {

				searchForm.classList.add('expanded');

				searchInput.setAttribute('tabindex', '0');
				searchInput.focus();
				searchInput.setAttribute('aria-expanded', 'true');

			}

		});

	}



	/*
		Mobile Menu (drawer)
		- https://flowbite.com/docs/components/drawer/#javascript-behaviour
	*/
	// set the drawer menu element
	const drawerEl = document.getElementById('drawer');

	// options with default value
	const drawerOptions = {
		placement: 'right',
		backdrop: true,
		backdropClasses: 'drawer-backdrop',
	};

	// instance options object
	const drawerInstance = {
		id: 'drawer',
	};

	const drawer = new Drawer (drawerEl, drawerOptions, drawerInstance);

	document.querySelector('#main-header .menu-open').addEventListener('click', () => {
		drawer.show();
	});

	document.querySelector('#drawer .menu-close').addEventListener('click', () => {
		drawer.hide();
	});

	document.querySelectorAll('#drawer li a').forEach((el) => {
		el.addEventListener('click', () => {
			drawer.hide();
		});
	});



	/*
		Header visibility by scroll position / direction
		- https://stackoverflow.com/a/7543724
		- https://stackoverflow.com/a/38196188
	*/

	let distance = 120,
		scrolled = false,
		delta = 5,
		lastSY = 0
	;

	window.addEventListener('scroll', () => {
		// Interval
		scrolled = true;
	});

	setInterval(() => {
		if (scrolled) {
			scrolled = false;
			header ();
		}
	}, 50);

	function header () {

		let SY = window.scrollY;
		if (Math.abs(lastSY - SY) <= delta) {
			return;
		}
		// Body class for navbar: pinned by scroll position
		if (SY > distance) {
			document.body.classList.add('pinned');
			// Body class for navbar: shifted on scroll up / down
			if (SY > lastSY) {
				// Scroll down
				document.body.classList.add('shifted');
				// Also close open dropdown menus
				document.body.click();
			} else {
				// Scroll up
				document.body.classList.remove('shifted');
			}
		} else {
			document.body.classList.remove('pinned', 'shifted');
		}
		lastSY = SY;

	}

	header ();

}
